import { dirname, join } from 'path'
import { fileURLToPath } from 'url'
import { existsSync, readFileSync } from 'fs'

const __dirname = dirname(fileURLToPath(import.meta.url))

/**
 * Searches upward for the nexus-backend package.json
 */
function findLibRoot(startDir: string): string {
  let dir = startDir
  while (dir !== '/') {
    const pkgPath = join(dir, 'package.json')
    if (existsSync(pkgPath)) {
      try {
        const pkg = JSON.parse(readFileSync(pkgPath, 'utf-8'))
        if (pkg.name === '@gzl10/nexus-backend') {
          return dir
        }
      } catch {
        // Continuar buscando
      }
    }
    dir = dirname(dir)
  }
  // Fallback: subir 2 niveles desde shared/
  return join(startDir, '../..')
}

// Cache del resultado
let _libPath: string | null = null

/**
 * Root path of the nexus-backend library.
 * - Dev: /project/nexus-backend/
 * - Lib: /user-project/node_modules/@gzl10/nexus-backend/
 */
export function getLibPath(): string {
  if (!_libPath) {
    _libPath = findLibRoot(__dirname)
  }
  return _libPath
}

/**
 * Root path of the user project (process.cwd).
 * - Dev: matches getLibPath()
 * - Lib: /user-project/
 */
export function getProjectPath(): string {
  return process.cwd();
}

/**
 * Searches for .env by walking up from cwd (max 5 levels).
 * Useful for monorepos where .env is at the root.
 */
export function findEnvFile(): string | null {
  let dir = process.cwd()
  for (let i = 0; i < 5; i++) {
    const envPath = join(dir, '.env')
    if (existsSync(envPath)) return envPath
    const parent = dirname(dir)
    if (parent === dir) break
    dir = parent
  }
  return null
}

/**
 * Core migrations directory (shipped with nexus-backend).
 * Located at {libPath}/migrations.
 */
export function getCoreMigrationsDir(): string {
  return join(getLibPath(), 'migrations')
}

/**
 * Project migrations directory (user's own modules).
 * Override with MIGRATIONS_DIR env var.
 */
export function getProjectMigrationsDir(): string {
  if (process.env['MIGRATIONS_DIR']) {
    return process.env['MIGRATIONS_DIR']
  }
  return join(getProjectPath(), 'migrations')
}

/**
 * Get the migrations directory path (backwards compat alias for getProjectMigrationsDir).
 */
export function getMigrationsDir(): string {
  return getProjectMigrationsDir()
}
